export default async function ultimaDecryptToken(token, decryptKey) {
  try {
    // Replace spaces with '+'
    token = token.replace(/ /g, "+");

    // Decode base64
    const encryptedData = Uint8Array.from(atob(token), (c) => c.charCodeAt(0));

    // Prepare key and IV
    const keyBuffer = new TextEncoder().encode(decryptKey);
    const iv = new Uint8Array(12); // 12-byte zero IV

    // Import key
    const cryptoKey = await window.crypto.subtle.importKey(
      "raw",
      keyBuffer,
      { name: "AES-GCM" },
      false,
      ["decrypt"]
    );

    // Decrypt
    const decrypted = await window.crypto.subtle.decrypt(
      {
        name: "AES-GCM",
        iv: iv,
        tagLength: 128,
      },
      cryptoKey,
      encryptedData
    );

    const decryptedText = new TextDecoder().decode(decrypted);

    // Parse JWT
    const chunks = decryptedText.split(".");
    const payload = JSON.parse(atob(chunks[1]));
    return payload;
  } catch (err) {
    console.error("Decryption failed:", err);
    return null;
  }
}
